import React, {Component} from 'react';
import VideoPlayer from "components/videoPlayer";

class OtherVideo extends Component {

  //设置自动播放
  playEnd = () => {
    const { selectedIndex, paperInfo, handleClick } = this.props;
    if(paperInfo && selectedIndex < paperInfo.interviewQuesVOs.length - 1){
      const index = selectedIndex + 1;
      const currentQuestion = paperInfo.interviewQuesVOs[index];
      handleClick(currentQuestion.questionId, index, true);
    }
  }

  render() {
    const { themeColor, videoUrl, autoPlay, handleTimeUpdate } = this.props;
    return (
      <div className="otherVideo">
        <VideoPlayer
          isOtherVideo={true}
          handleEnded={this.playEnd}
          autoPlay={autoPlay}
          handleTimeUpdate={handleTimeUpdate}
          videoUrl={videoUrl}
          themeColor={themeColor} />
      </div>
    );
  }
}

export default OtherVideo;
